import { CreateFunnelTemplate, FunnelTemplate } from '@marketing-milk/interfaces'
import { NestAPI } from 'app/nestapi'
import { FunnelTemplateService } from './FunnelTemplateService.types'

export class FunnelTemplateServiceImplementation implements FunnelTemplateService {
  // The `as any as Promise<T>` casts are required rather than sloppy: the
  // response interceptor (components/utility/interceptor.tsx) unwraps
  // `response.data.body`, so NestAPI resolves to the payload while TypeScript
  // still believes it is an AxiosResponse.
  async getAll() {
    return NestAPI.get('funnel-templates') as any as Promise<FunnelTemplate[]>
  }

  async create(template: CreateFunnelTemplate) {
    return NestAPI.post('funnel-templates', template) as any as Promise<FunnelTemplate>
  }

  async delete(templateID: number) {
    return NestAPI.delete(`funnel-templates/${templateID}`) as any as Promise<void>
  }
}
